import React from 'react';
import { getAccreditationLabel } from '../labelGetters';

export default function AccreditationDisplay({
  accreditation,
  labels,
  isNew = false,
}) {
  const accreditationId = accreditation.accreditationId || accreditation.id;
  const displayName =
    getAccreditationLabel(accreditationId, labels) ||
    `Accreditation #${accreditationId}`;
  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';

  return (
    <div
      className={`flex items-center gap-2 p-2 bg-gray-50 rounded border ${borderClass}`}
    >
      <i className="fa-regular fa-certificate text-amber-500" />
      <span className="text-sm text-gray-700">{displayName}</span>
    </div>
  );
}
